import { Fade, Grid, Typography, useMediaQuery } from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import parseReactComponents from "../functions/parseReactComponents";

export default function ContentTabs({data}){

    const mobile=useMediaQuery(theme=>theme.breakpoints.down('md'));

    const [activeTab, setActiveTab]=useState(0);
    const [tabHeight, setTabHeight]=useState(0);

    const activeTabRef=useRef();

    useEffect(()=>{
        if(activeTabRef.current){
            setTabHeight(activeTabRef.current.clientHeight);
        }
    },[data, activeTab, activeTabRef]);

    //console.log(tabHeight)

    return(
        <Container maxWidth='xl'>
            <Box
                sx={{
                    mb:'2rem',
                    position:'relative',
                    height: mobile? '700px' : tabHeight+'px',
                    transition:'height 0.5s'
                }}
            >
                {data?
                    data.map((tab, i)=>{
                        return(
                            <Box
                                ref={activeTab===i? activeTabRef : null}
                                sx={{
                                    position: 'absolute',
                                    top:0,
                                    width:'100%',
                                    zIndex: activeTab===i? 0 : -1
                                }}
                            >
                                <Fade in={activeTab===i}>
                                    <Grid container spacing={2}
                                        sx={{
                                            height:'100%',
                                            minHeight: '508px',
                                            alignContent: 'stretch'
                                        }}
                                    >
                                        <Grid item xs={12} md={5}
                                            sx={{
                                                display:'flex',
                                                flexDirection:'column',
                                                justifyContent:'center'
                                            }}
                                        >
                                            <Typography variant='h2'
                                                sx={{
                                                    color:'rgb(233, 83, 28)',
                                                    fontWeight:600,
                                                    mb:'1rem'
                                                }}
                                            >
                                                {tab.heading}
                                            </Typography>
                                            {parseReactComponents(tab.content)}
                                        </Grid>
                                        <Grid item xs={0} md={1}/>
                                        <Grid item xs={12} md={6}
                                            sx={{
                                                display:'flex',
                                                alignItems:'center'
                                            }}
                                        >
                                            <img
                                                src={tab.image.url}
                                                width='100%'
                                                style={{
                                                    objectFit:'cover',
                                                    objectPosition:'center',
                                                    width:'100%',
                                                    height:'100%'
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Fade>
                            </Box>
                        );
                    })
                :
                    null
                }
            </Box>
            <Box
                sx={{
                    display:'flex',
                    justifyContent:'center',
                    mb:'2rem'
                }}
            >
                {data && data.map((tab, i)=>{
                    return(
                        <Box
                            onClick={()=>setActiveTab(i)}
                            sx={{
                                height:'1rem',
                                width:'1rem',
                                m:'0 0.5rem',
                                backgroundColor: activeTab===i? '#265DA5' : 'grey',
                                borderRadius:'50%',
                                cursor:'pointer'
                            }}
                        />
                    )
                })}
            </Box>
        </Container>
    );
}